import { render } from "./RegistrationClinicStepTwo.vue?vue&type=template&id=60dbe520&scoped=true"
import script from "./RegistrationClinicStepTwo.vue?vue&type=script&lang=js"
export * from "./RegistrationClinicStepTwo.vue?vue&type=script&lang=js"

import "./RegistrationClinicStepTwo.vue?vue&type=style&index=0&id=60dbe520&lang=scss&scoped=true"
import "./RegistrationClinicStepTwo.vue?vue&type=style&index=1&id=60dbe520&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dbe520"]])

export default __exports__